import { Injectable } from "@angular/core";
import { AnimationsConfig } from "controls";

@Injectable({ providedIn: 'root' })
export class AnimationsConfigImpl extends AnimationsConfig {
    animationsEnabled(): boolean {
        return true;
    }
    backdropClass(): string | null {
        return null;
    }
}
